import { MedicationAdminPanel } from '../components/MedicationAdminPanel';

export default function Admin() {
  return <MedicationAdminPanel />;
}